import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import Quill from 'quill';
import { forkJoin, Observable } from 'rxjs';
import { TradeeService } from 'src/app/core/services/http/trade-mgmt/trade.service';
import { NoteTagUserResult } from 'src/app/job/models/job-detail/Notes/notes.result.model';
import { PropertySearchService } from 'src/app/core/services/http/Property/property-search.service';
import { debounce } from 'lodash';
import "quill-mention/autoregister";
import {Mention, MentionBlot} from 'quill-mention';
import QuillBetterTable from 'quill-better-table';

@Component({
  selector: 'app-quill-editor',
  templateUrl: './quill-editor.component.html',
  styleUrls: ['./quill-editor.component.scss'],
})
export class QuillEditorComponent implements OnInit {
  quill: any;
  isNoteByUniqueName: boolean = false;
  noteHtmlContent: string;
  @Input() JobId: string;
  @Input() UserId: string;
  @Input() PropertyId: string;
  @Input() IsLoadTagUsers: boolean;
  @Input() QuillUniqueName: string;
  @Output() QuillEditorChange = new EventEmitter();
  @Input() IsPreviewOnly: Boolean = false;
  @Input() isEnableMinimumTools: boolean = false;
  @Input() IsPreventCopyPaste: boolean = false;
  @Output() quillEditorContentPasted = new EventEmitter();
  @Input() set backgroundImageUrl(value: string) {
    if (value && value != '') {
      window.setTimeout(() => {
        const quillTableWrapper = this.el.nativeElement.querySelector('.quill-better-table-wrapper');
        if (quillTableWrapper) {
          this.renderer.setStyle(quillTableWrapper, 'background-image', `url(${value})`);
        }    
      }, 500);
    }
  }

  @Input() set backgroundColor(value: string) {
    if (value && value != '') {
      window.setTimeout(() => {
        const quillTableWrapper = this.el.nativeElement.querySelector('.quill-better-table-wrapper');
        if (quillTableWrapper) {
          this.renderer.setStyle(quillTableWrapper, 'background', `${value}`);
        }    
      }, 500);
    }
  }


  @Input() set Note(value: string) {
    if (value || value == '') {
      window.setTimeout(() => {
        this.quill.focus();        
         const delta = this.quill.clipboard.convertHTML(value)
         this.quill.setContents(delta);       
      }, 1200);
    }
  }

  @Input() set NoteByUniqueName(value: string) {        
    if (value || value == '') {  
      this.isNoteByUniqueName = true;
      this.noteHtmlContent = value;
      window.setTimeout(() => { 
        this.quill.focus();
         if(!this.IsPreviewOnly){          
          const delta = this.quill.clipboard.convertHTML(value);
          this.quill.setContents(delta);
        }
      }, 1200);
    }
  }

  TaggingUserList = [];

  constructor(
    private propertyService: PropertySearchService,
    private tradeService: TradeeService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention }); 
    Quill.register({'modules/better-table': QuillBetterTable}, true)   
    this.loadTextEditor(
      this.IsLoadTagUsers,
      this.propertyService,
      this.tradeService,
      this.PropertyId,
      this.QuillUniqueName
    );
  }

  loadTextEditor(
    IsLoadTagUsers,
    propertyService,
    tradeService,
    PropertyId,
    QuillUniqueName
  ): void {
    var quillEditor = document.getElementById('quill-editor-note');
    quillEditor.setAttribute('id', QuillUniqueName);
    var TaggingUserList = [];
    var fonts = [
      'sans-serif','serif','monospace'
    ];  

    if (IsLoadTagUsers) {
      this.quill = new Quill('#' + QuillUniqueName, {
        modules: {
          table: false,
          'better-table': {
            operationMenu: {
              items: {                
              }
            }
          },         
          toolbar:this.IsPreviewOnly ? false : {
            container: this.setToolBar(),
            handlers: {
              undo: this.Undo,
              redo: this.Redo,
            },
          },
          mention: {            
            allowedChars: /^[a-zA-Z0-9_\sÅÄÖåäö]*$/,
            mentionDenotationChars: ['@', '#'],
            onOpen: function () {
              var li = document.getElementsByClassName('ql-mention-list-item');
              for (var i = 0; i < li.length; i++) {
                var node = document.createElement('IMG');
                var img =
                  TaggingUserList[i].profileImageUrl == null ||
                  TaggingUserList[i].profileImageUrl == undefined ||
                  TaggingUserList[i].profileImageUrl == ''
                    ? 'https://icon-library.com/images/profile-icon-white/profile-icon-white-27.jpg'
                    : TaggingUserList[i].profileImageUrl;

                li[i].innerHTML =
                  '<img src="' +
                  img +
                  '" style="width: 20px; height: 20px;"> &nbsp; &nbsp;' +
                  li[i].innerHTML;
              }
            },
            onSelect: function (item, insertItem) {
              insertItem(item);
              if(this.isNoteByUniqueName){
                document.getElementById(this.QuillUniqueName)[0].innerHTML = (
                  document.getElementsByClassName(this.QuillUniqueName)[0].innerHTML as any
                ).replaceAll('@', '');
                setTimeout(() => { const endIndex = this.quill.getLength(); this.quill.setSelection(endIndex, 0);}, 0); 
              }
             else{ 
              const delta = this.quill.getContents();
              delta.ops = delta.ops.map((op: any) => {
                if (op.insert && typeof op.insert === 'object' && op.insert.mention) {
                  const mention = op.insert.mention;
                  mention.denotationChar = mention.denotationChar.replace('@', ''); 
                  mention.value = mention.value.replace('@', ''); 
                  op.insert.mention = mention; 
                }
                else if (op.insert && typeof op.insert === 'string') {
                  op.insert = op.insert.replaceAll('@', '');
                }
                return op;
              }); 
              this.quill.setContents(delta);
              setTimeout(() => { const endIndex = this.quill.getLength(); this.quill.setSelection(endIndex, 0);}, 0);  
            }
            },
            source: debounce (function(searchTerm, renderList) {
              let values;
              if (searchTerm.length >= 3 && !/\s/g.test(searchTerm)) {
                this.quill.enable(false);

                var propUser: Observable<NoteTagUserResult[]> =
                  propertyService.getPropertyUsersForNoteTags(
                    PropertyId,
                    searchTerm
                  );
                var trades: Observable<NoteTagUserResult[]> =
                tradeService.getNoteTagTrades(searchTerm);
                this.subUser = forkJoin([propUser, trades]).subscribe(
                  ([propUser, trade]: [
                    NoteTagUserResult[],
                    NoteTagUserResult[]
                  ]) => {
                    this.quill.enable(true);
                    TaggingUserList = propUser.concat(trade);
                    var users = TaggingUserList?.map(function (item) {
                      return {
                        id: item.id,
                        value: item.firstName + ' ' + item.lastName,
                      };
                    });
                    values = users;   
                    if(values.length == 0)setTimeout(() => { const endIndex = this.quill.getLength(); this.quill.setSelection(endIndex, 0);}, 0);                          
                    if (searchTerm.length < 3) {
                      renderList(values, searchTerm);
                    } else {
                      const matches = [];
                      for (let i = 0; i < values?.length; i++)
                        if (
                          ~values[i].value
                            .toLowerCase()
                            .indexOf(searchTerm.toLowerCase())
                        )
                          matches.push(values[i]);
                      renderList(matches, searchTerm);
                    }
                  }
                );
              }
            },1000),
          },
        },
        placeholder: '',
        theme:'snow',
      });
    } else {
      this.quill = new Quill('#' + QuillUniqueName, {
        modules: {
          table: false,
          'better-table': {
            operationMenu: {
              items: {               
              }
            }
          },         
          toolbar:this.IsPreviewOnly ? false : {
            container: this.setToolBar(),
            handlers: {
              undo: this.Undo,
              redo: this.Redo,
            },
          },
        },
        placeholder: '',
        theme:'snow',
      });
    }
    if(this.IsPreviewOnly){
      this.quill.clipboard.dangerouslyPasteHTML(this.noteHtmlContent);
    }   
    if(this.IsPreventCopyPaste)
    {
      this.quill.root.addEventListener('paste', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.quillEditorContentPasted.emit();
      },true); 
    }
    this.quill.on('text-change', () => {
      if(this.isNoteByUniqueName && !this.IsPreviewOnly){    
      this.hideSpecificAnchorTags();
      }
      this.QuillEditorChange.emit(this.quill.root.innerHTML);
    });
  }

  hideSpecificAnchorTags() {
    var anchors = document.querySelectorAll('a[href="approveRejectBtn"]');
    if(anchors && anchors.length > 0){
      anchors.forEach(function(anchor) {
        const anchorElement = anchor as HTMLElement;
        anchorElement.style.display = 'none'; 
        });
    }
  }
  
  clearEditorContent(){
    if (this.quill) {
      this.quill.setText(''); 
    }
  }

  Undo = () => {
    return this.quill.history.undo();
  };
  Redo = () => {
    return this.quill.history.redo();
  };

setToolBar(){
  var fonts = [
    'sans-serif','serif','monospace'
  ];  
if(this.isEnableMinimumTools){
  return [
    ['bold'],
    [{ 'list': 'bullet' }],
  ]
}
return [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  ['link'],
  [{ header: 1 }, { header: 2 }],
  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ 'size': ['small', false, 'large', 'huge'] }],
  [{ color: [] }, { background: [] }],
  [{ font: fonts }],
  [{ align: [] }],
  ['clean']
]
}

}
